import { makeAutoObservable } from 'mobx';

import { appConfig } from '~/appConfig';
import { IBaseStore } from '~/base/types/BaseTypes';

import LangService from './LangService';
import { LangTypeEnum, ILang } from './types/Lang';

export class LangStore implements IBaseStore {
  lang: LangTypeEnum = appConfig.defaultLanguage;
  langs: ILang[] = appConfig.languages;

  private langService: LangService;

  constructor() {
    makeAutoObservable(this);

    this.langService = new LangService();
  }

  // INIT

  init = async () => {
    const lang = this.langService.getLang();

    await this.changeLang((lang as LangTypeEnum) ?? appConfig.defaultLanguage);
  };

  // OTHERS

  changeLang = async (lang: LangTypeEnum) => {
    this.setLang(lang);

    await this.langService.changeLang(lang);
  };

  // RESET

  reset = () => {};

  // SETTERS

  private setLang = (lang: LangTypeEnum) => {
    this.lang = lang;
  };
}
